import React, { useContext } from 'react';
import Link from 'next/link';
import { PortalContext } from '../../context';
export const CustomLink = ({ href, children }) => {
    const { isPortal } = useContext(PortalContext);
    // Link component loads the same page while only updating hero component
    return isPortal ? (React.createElement(Link, { href: href, passHref: true, locale: false, legacyBehavior: true }, children)) : (React.createElement(React.Fragment, null, children));
};
//# sourceMappingURL=index.js.map